export const PUBLIC_OFFER = {
  URL: '/public_offer',
  TITLE: 'Публичная оферта'
}


// WEBPACK FOOTER //
// ./src/features/PublicOffer/links.js